export default "__VITE_ASSET__DpLX9gKR__"